import * as React from 'react'

import { Box, type Colors, InfoDot } from '@factorialco/deprecated-design-system'

type LegendItemProps = {
  color: Colors
}

type BoxProperties = typeof Box
type CombinedProps = React.ComponentPropsWithoutRef<BoxProperties> & LegendItemProps

const LegendItem: React.FC<CombinedProps> = (props) => {
  const { children, color, style, ...restProps } = props

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s4"
      style={{
        maxWidth: '300px', //Limit to avoid long elements
        ...style,
      }}
      {...restProps}
    >
      <InfoDot size="small" color={color} />
      <span
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </span>
    </Box>
  )
}

export default LegendItem
